import { Box, BoxProps } from '@chakra-ui/react';
import React from 'react';

export const FormBox = ({ children, ...rest }: BoxProps) => {
  return (
    <Box
      w="100%"
      h="100%"
      boxShadow="0px 3px 7px #00000050"
      background="white"
      padding="25px"
      {...rest}
    >
      {children}
    </Box>
  );
};
